//
//
//
//
//
//
//
//
//
//
//
//
//
//

import round from '~/mixins/round'

export default {
  name: 'BoatReviewSimple',
  mixins: [round],
  props: {
    boat: {
      type: Object,
      default: () => {}
    },
    link: {
      type: [String, Boolean],
      default: '#reviews-section'
    }
  },
  computed: {
    getReviewValue () {
      return this.boat.average_rating || parseFloat(this.boat.rating)
    },
    getReviewCount () {
      return this.boat.review_count || parseInt(this.boat.reviewCount, 10)
    },
    getReviewValueText () {
      return this.getTextByRating(this.getReviewValue)
    }
  }
}
